import { Link } from "react-router-dom";

const LOGO =
  "https://customer-assets.emergentagent.com/job_5d53cc0c-f8e0-4354-807b-347bf58e1216/artifacts/3rlolaxv_Logo.png";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-axe-border bg-axe-bg" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO} alt="AXE" className="h-10 w-10 glow-purple" />
            <div>
              <div className="font-display font-black tracking-[0.25em] text-white">AXE</div>
              <div className="text-[11px] uppercase tracking-[0.3em] text-axe-tangerine">
                Anti Xquad'E
              </div>
            </div>
          </div>
          <p className="mt-4 text-sm text-neutral-400 max-w-xs">
            A professional esports organization forged for Valorant, Apex Legends, and Call of
            Duty.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-neutral-500 mb-3">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/roster" className="hover:text-axe-purple">Roster</Link></li>
            <li><Link to="/tournaments" className="hover:text-axe-purple">Tournaments</Link></li>
            <li><Link to="/live" className="hover:text-axe-purple">Live Stream</Link></li>
            <li><Link to="/news" className="hover:text-axe-purple">News</Link></li>
            <li><Link to="/media" className="hover:text-axe-purple">Media</Link></li>
            <li><Link to="/about" className="hover:text-axe-purple">About</Link></li>
            <li><Link to="/recruitment" className="hover:text-axe-purple">Recruitment</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-neutral-500 mb-3">Community</div>
          <ul className="space-y-2 text-sm">
            <li><a href="https://discord.gg/antixquade" target="_blank" rel="noreferrer" className="hover:text-axe-tangerine">Discord</a></li>
            <li><a href="https://www.twitch.tv/antixquade" target="_blank" rel="noreferrer" className="hover:text-axe-tangerine">Twitch</a></li>
            <li><Link to="/sponsors" className="hover:text-axe-tangerine">Sponsors</Link></li>
            <li><Link to="/faq" className="hover:text-axe-tangerine">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-axe-tangerine">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-neutral-500 mb-3">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/terms" className="hover:text-axe-purple" data-testid="footer-terms-link">Terms of Service</Link></li>
            <li><Link to="/privacy" className="hover:text-axe-purple" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/admin/login" className="hover:text-axe-purple" data-testid="footer-admin-link">Staff Login</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-axe-border">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 text-xs text-neutral-500 flex flex-col md:flex-row gap-2 md:items-center md:justify-between">
          <div>© {new Date().getFullYear()} Anti Xquad'E. All rights reserved.</div>
          <div className="uppercase tracking-[0.3em]">Forge · Adapt · Dominate</div>
        </div>
      </div>
    </footer>
  );
}
